module.exports = __webpack_public_path__ + "84bde868690cd91fc1037cb37bec392b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/favorite/hoaqua.jpg
// module id = ./assets/images/favorite/hoaqua.jpg
// module chunks = 0